module.exports = __webpack_public_path__ + "img/tepepay.9983a00b.png";